import { render, staticRenderFns } from "./sortMenu.vue?vue&type=template&id=7ca46961&lang=pug&"
import script from "./sortMenu.vue?vue&type=script&lang=js&"
export * from "./sortMenu.vue?vue&type=script&lang=js&"
import style0 from "./sortMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca46961')) {
      api.createRecord('7ca46961', component.options)
    } else {
      api.reload('7ca46961', component.options)
    }
    module.hot.accept("./sortMenu.vue?vue&type=template&id=7ca46961&lang=pug&", function () {
      api.rerender('7ca46961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/sortMenu.vue"
export default component.exports